const initialState = () => {
    return {
        isRouteInfoComplete: false,
        isTravelOptionsComplete: false,
        isContactComplete: false,
        routeInfo: {
            start_place: null,
            end_place: null,
            departure_date: null,
            departure_time: '',
            return_date: null,
            return_time: '',
            one_way: false,
            passengers_number: 1,
        },
        travelOptionComments: null,
        travelOptions: {
            plane_option: null,
            transfer_option: null,
            insurance: false,
            hotel_option: {
                hotel_preference: null,
                hotel_stars: null,
            },
            ferry_option: {
                start_place: null,
                end_place: null,
            },
            train_option: {
                start_place: null,
                end_place: null,
            },
            coach_option: {
                start_place: null,
                end_place: null,
            },
            formal_assistance: false,
            event_assistance: false,
        },
        contact: {
            name: null,
            company_name: null,
            address: null,
            tax_number: null,
            phone: null,
            email: null,
            post_code: null,
            city: null,
            country: null,
            password: null,
            password_confirmation: null,
        },
        createAccount: false,
    };
};

const state = initialState;

const getters = {
    getRouteInfo(state) {
        return state.routeInfo;
    },

    getTravelOptions(state) {
        return state.travelOptions;
    },

    getPlaneOption(state) {
        return state.travelOptions.plane_option;
    },

    getTransferOption(state) {
        return state.travelOptions.transfer_option;
    },

    getHotelOption(state) {
        return state.travelOptions.hotel_option;
    },

    getInsuranceOption(state) {
        return state.travelOptions.insurance;
    },

    getFerryOption(state) {
        return state.travelOptions.ferry_option;
    },

    getTrainOption(state) {
        return state.travelOptions.train_option;
    },

    getCoachOption(state) {
        return state.travelOptions.coach_option;
    },

    getFormalAssistance(state) {
        return state.travelOptions.formal_assistance;
    },

    getEventAssistance(state) {
        return state.travelOptions.event_assistance;
    },

    getContact(state){
        return state.contact;
    },

    getTravelOptionComments: (state) => {
        return state.travelOptionComments;
    },

    getCreateAccount: (state) => {
        return state.createAccount;
    },

    getIsRouteInfoComplete: (state) => {
        return state.isRouteInfoComplete;
    },

    getIsTravelOptionsComplete: (state) => {
        return state.isTravelOptionsComplete;
    },

    getIsContactComplete: (state) => {
        return state.isContactComplete;
    },
};

const mutations = {
    setRouteInfo(state, info) {
        state.routeInfo = info;
    },

    setTravelOptions(state, options) {
        state.travelOptions = options;
    },

    setCode(state, code) {
        state.code = code;
    },

    setSearchParameters(state, parameters) {
        state.searchParameters = parameters;
    },

    setTransferType(state, transferType) {
        state.transferType = transferType;
    },

    setTransferTypeComment(state, transferTypeComment) {
        state.transferTypeComment = transferTypeComment;
    },

    setContact(state, contact) {
        state.contact = contact;
    },

    setTravelOptionComments(state, comments) {
        state.travelOptionComments = comments;
    },

    setPlaneOption(state, option) {
        state.travelOptions.plane_option = option;
    },

    setCreateAccount: (state, value) => {
        state.createAccount = value;
    },

    setIsRouteInfoComplete: (state, value) => {
        state.isRouteInfoComplete = value;
    },

    setIsTravelOptionsComplete: (state, value) => {
        state.isTravelOptionsComplete = value;
    },

    setIsContactComplete: (state, value) => {
        state.isContactComplete = value;
    },

    reset(state) {
        const initial = initialState();

        Object.keys(initial).forEach((key) => {
            state[key] = initial[key];
        });
    },
};

const actions = {
    setRouteInfo({ commit }, info) {
        commit('setRouteInfo', info);
    },

    setTravelOptions({ commit }, options) {
        commit('setTravelOptions', options);
    },

    setPlaneOption({ commit }, option) {
        commit('setPlaneOption', option);
    },

    setContact({ commit }, contact) {
        commit('setContact', contact);
    },

    setTravelOptionComments({commit}, comments) {
        commit('setTravelOptionComments', comments);
    },

    setCreateAccount({commit}, value) {
        commit('setCreateAccount', value);
    },

    setIsRouteInfoComplete({commit}, value) {
        commit('setIsRouteInfoComplete', value);
    },

    setIsTravelOptionsComplete({commit}, value) {
        commit('setIsTravelOptionsComplete', value);
    },

    setIsContactComplete({commit}, value) {
        commit('setIsContactComplete', value);
    },

    reset({ commit }) {
        commit('reset');
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
